import api from "@/apis/DashboardAPI";

const state = {};
const getters = {};
const actions = {
  getSummaryAssetQuantityByStatus: async function (context, payload) {
    let res = await api.getSummaryAssetQuantityByStatus(payload);
    if (res) return res;
    else return null;
  },
};
const mutations = {};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
